<template>

    <b-modal
        id="area-modal"
        size="md"
        :title="action === 'add' ? 'Utwórz obszar' : 'Edytuj obszar'"
        ok-title="Zapisz"
        cancel-title="Anuluj"
        ok-variant="success"
        no-close-on-backdrop
        @ok="areaModalHandleOk"
        @hidden="areaModalHandleHide">
        <form @submit.prevent="submitAreaForm" @keydown="form.errors.clear($event.target.name)" ref="area-form">

            <div class="row">

                <div class="col-md-6">

                    <div class="form-group">
                        <label for="area_display_name">Nazwa wyświetlana</label>
                        <input type="text" class="form-control" id="area_display_name" v-model="form.display_name" @input="validateDisplayNameCharInput($event)">
                        <small class="form-text text-muted">Tłumaczenie w bazowym języku (angielski).</small>
                        <span class="error mt-2 text-danger" v-if="form.errors.has('display_name')" v-text="form.errors.get('display_name')"></span>
                    </div>

                    <div class="form-group">
                        <label for="area_display_description">Opis wyświetlany</label>
                        <textarea class="form-control" rows="3" id="area_display_description" v-model="form.display_description" @input="validateDisplayDescriptionCharInput($event)"></textarea>
                        <small class="form-text text-muted">Tłumaczenie w bazowym języku (angielski).</small>
                        <span class="error mt-2 text-danger" v-if="form.errors.has('display_description')" v-text="form.errors.get('display_description')"></span>
                    </div>

                    <div class="form-group">
                        <label for="area_output_identification_name">Identyfikator wewnętrzny</label>
                        <input type="text" class="form-control" id="area_output_identification_name" v-model="form.output_identification_name" @input="validateOutputIdentificationNameCharInput($event)">
                        <small class="form-text text-muted" v-if="action === 'edit'">Zmiana spowoduje modyfikację kluczy tłumaczeń w repozytorium, jednak wszystkie tłumaczenia zostaną zachowane.</small>
                        <span class="error mt-2 text-danger" v-if="form.errors.has('output_identification_name')" v-text="form.errors.get('output_identification_name')"></span>
                    </div>

                    <div class="mb-4">
                        <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="always_visible" v-model="form.always_visible">
                            <label class="custom-control-label" for="always_visible" style="font-size: 0.875rem; line-height: 1.6;">Zawsze widoczny</label>
                        </div>
                        <span class="error mt-2 text-danger" v-if="form.errors.has('always_visible')" v-text="form.errors.get('always_visible')"></span>
                    </div>

                </div>

                <div class="col-md-6">

                    <div class="form-group">
                        <label>Ikona</label>
                        <file-manager-image-select :input-name="'icon'" :value="form.icon" v-model="form.icon" :mime-types="'image/gif,image/jpeg,image/png,image/tiff,image/bmp,image/x-xbitmap'" :crop-available="true" :crop-aspect-ratio="1" :width="240"></file-manager-image-select>
                        <span class="error mt-2 text-danger" v-if="form.errors.has('icon')" v-text="form.errors.get('icon')"></span>
                    </div>

                    <div class="form-group">
                        <label for="area_overlay_color">Kolor przesłony</label>
                        <input type="color" class="form-control" id="area_overlay_color" v-model="form.overlay_color">
                        <span class="error mt-2 text-danger" v-if="form.errors.has('overlay_color')" v-text="form.errors.get('overlay_color')"></span>
                    </div>

                    <div class="form-group">
                        <label for="area_overlay_color">Kolor tła</label>
                        <input type="color" class="form-control" id="area_background_color" v-model="form.background_color">
                        <span class="error mt-2 text-danger" v-if="form.errors.has('background_color')" v-text="form.errors.get('background_color')"></span>
                    </div>

                </div>

            </div>

        </form>
    </b-modal>

</template>

<script>

    import {inputValidators} from '../../mixins/inputValidators';
    import Image from "../../../../../../FileManager/Resources/assets/js/classes/Image";

    export default {

        name: 'GameLibraryAreaModal',

        mixins: [inputValidators],

        props: [
            'repo',
            'library'
        ],

        data() {
            return {
                eventHub: window.eventHub,
                action: null,
                id: null,
                form: new Vue.prototype.Form({
                    output_identification_name: null,
                    display_name: null,
                    display_description: null,
                    always_visible: false,
                    icon: null,
                    overlay_color: '#ffffff',
                    background_color: '#ffffff'
                })
            }
        },

        mounted() {

            // Set variables and show modal in edit state
            this.eventHub.$on('game-library-add-area', () => {
                this.action = 'add';
                this.id = null;
                this.form = new Vue.prototype.Form({
                    output_identification_name: null,
                    display_name: null,
                    display_description: null,
                    always_visible: false,
                    icon: null,
                    overlay_color: '#ffffff',
                    background_color: '#ffffff'
                });
                this.$bvModal.show('area-modal');
            });

            // Set variables and show modal in edit state
            this.eventHub.$on('game-library-edit-area', (area) => {
                this.action = 'edit';
                this.id = area.id;
                this.form = new Vue.prototype.Form({
                    output_identification_name: area.output_identification_name,
                    display_name: area.display_name,
                    display_description: area.display_description,
                    always_visible: area.always_visible,
                    icon: new Image(area.icon_url),
                    overlay_color: area.overlay_color,
                    background_color: area.background_color
                });
                this.$bvModal.show('area-modal');
            });

        },

        methods: {

            areaModalHandleOk(event) {
                event.preventDefault();
                this.submitAreaForm();
            },

            areaModalHandleHide() {
                this.action = null;
                this.id = null;
                this.form = new Vue.prototype.Form({
                    output_identification_name: null,
                    display_name: null,
                    display_description: null,
                    always_visible: false,
                    icon: null,
                    overlay_color: '#ffffff',
                    background_color: '#ffffff'
                });
            },

            submitAreaForm() {
                this.eventHub.$emit('processing-start');
                if (this.action === 'add') {
                    this.form.post(route('game::game-library.store-area', {repo: this.repo}))
                        .then(response => {
                            this.eventHub.$emit('game-library-updated', response.data.library);
                            this.$bvModal.hide('area-modal');
                            this.eventHub.$emit('processing-finish');
                            this.eventHub.$emit('toast-notification', response.message, 'success');
                        })
                        .catch(error => {
                            console.log(error);
                            this.eventHub.$emit('processing-finish');
                            this.eventHub.$emit('toast-notification', 'Coś poszło nie tak. Sprawdź poprawność danych.', 'error');
                        });
                } else if (this.action === 'edit') {
                    this.form.put(route('game::game-library.update-area', {repo: this.repo, id: this.id}))
                        .then(response => {
                            this.eventHub.$emit('game-library-updated', response.data.library);
                            this.$bvModal.hide('area-modal');
                            this.eventHub.$emit('processing-finish');
                            this.eventHub.$emit('toast-notification', response.message, 'success');
                        })
                        .catch(error => {
                            console.log(error);
                            this.eventHub.$emit('processing-finish');
                            this.eventHub.$emit('toast-notification', 'Coś poszło nie tak. Sprawdź poprawność danych.', 'error');
                        });
                }

            }

        }

    }
</script>

<style scoped>

</style>
